import { createSelector } from '@reduxjs/toolkit'

// First select the relevant part from the state
export const adminCategoryState = (state) => state.adminCategory
export const selectAdminCategoryListingData = createSelector(adminCategoryState, (state) => state)

